/**
 * app-header.js
 * eimy istoire APP — ヘッダー制御スクリプト
 */

(function () {
  'use strict';

  const ecHeader        = document.querySelector('x-header');
  const announcementBar = document.querySelector('.shopify-section--announcement-bar');

  if (!ecHeader) return;

  const isHomePage =
    document.body.classList.contains('app-pg-app-home') ||
    document.body.classList.contains('app-home');

  /* ─────────────────────────────────────────────────────
     CSS変数を正確な実測値で上書き
     （ECヘッダーのインラインスクリプトより後に実行）
  ───────────────────────────────────────────────────── */
  function setCSSVars() {
    const headerSection = ecHeader.closest('[id^="shopify-section-"]');
    if (headerSection) {
      document.documentElement.style.setProperty(
        '--header-height',
        headerSection.offsetHeight + 'px'
      );
    }
    if (announcementBar) {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        announcementBar.offsetHeight + 'px'
      );
    }
  }

  /* ─────────────────────────────────────────────────────
     スクロール検知
     is-pinned: アナウンスバーが画面外に出たタイミングで付与
               → HOMEのKV透過解除トリガー
  ───────────────────────────────────────────────────── */
  let scrollTicking = false;

  function handleScroll() {
    if (scrollTicking) return;
    scrollTicking = true;

    requestAnimationFrame(function () {
      if (announcementBar) {
        const barBottom = announcementBar.getBoundingClientRect().bottom;
        const pinned    = barBottom <= 0;

        ecHeader.classList.toggle('is-solid', pinned);
        document.body.classList.toggle('is-solid', pinned);
      }

      scrollTicking = false;
    });
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', function () {
    setCSSVars();
    handleScroll();
  }, { passive: true });

  /* 初期実行 */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setCSSVars();
      handleScroll();
    });
  } else {
    setCSSVars();
    handleScroll();
  }

})();